import { render, staticRenderFns } from "./CarPDF.vue?vue&type=template&id=3d08169a&scoped=true&lang=pug&"
import script from "./CarPDF.vue?vue&type=script&lang=js&"
export * from "./CarPDF.vue?vue&type=script&lang=js&"
import style0 from "./CarPDF.vue?vue&type=style&index=0&id=3d08169a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d08169a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VIcon,VSimpleTable})
